
import React from 'react';
import { SlideData } from '../types';

interface SlideProps {
  data: SlideData;
}

const Slide: React.FC<SlideProps> = ({ data }) => {
  const isSpecialSlide = data.type === 'title' || data.type === 'closing';

  return (
    <div className={`w-full h-full flex flex-col justify-center px-[8%] slide-content-container ${isSpecialSlide ? 'items-center text-center' : ''}`}>
      <div className={`${isSpecialSlide ? 'mb-12' : 'mb-8'}`}>
        <h1 className={`font-black tracking-tighter leading-tight mb-4 animate-in slide-in-from-bottom-4 duration-500
          ${data.type === 'title' ? 'text-9xl mb-10' : data.type === 'closing' ? 'text-9xl' : 'text-8xl'}
          ${data.accentColor ? `text-[${data.accentColor}]` : 'text-white'}
        `}>
          {data.title}
        </h1>
        {data.subtitle && (
          <p className={`text-4xl text-gray-400 font-light whitespace-pre-wrap leading-tight max-w-5xl ${isSpecialSlide ? 'mx-auto' : ''}`}>
            {data.subtitle}
          </p>
        )}
      </div>

      <div className={`flex flex-col lg:flex-row gap-16 items-center justify-between w-full`}>
        {data.points && data.points.length > 0 && (
          <div className="flex-1 space-y-8 animate-in slide-in-from-left-4 duration-500">
            {data.points.map((point, i) => (
              <div key={i} className="flex items-start gap-6">
                <div className="w-3 h-3 rounded-full bg-purple-500 mt-4 flex-shrink-0 shadow-[0_0_15px_rgba(139,92,246,0.5)]" />
                <p className="text-3xl font-medium text-gray-200 leading-snug">{point}</p>
              </div>
            ))}
          </div>
        )}
        
        {data.extraContent && (
          <div className={`w-full flex justify-center animate-in fade-in duration-500 ${data.points ? 'lg:w-[60%] lg:flex-shrink-0' : 'max-w-full'}`}>
            <div className="w-full">
              {data.extraContent}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Slide;
